import type { PriorVersionSummary } from '@planuze/admin-contracts';
import { EmptyState, StatusBadge } from '@planuze/ui';
import { GitBranch } from 'lucide-react';
import { usePackSubmissionsContent } from '../../content/sections/pack-submissions.js';
import { fmtDate } from '../../lib/format.js';
import { submissionLabel, submissionTone } from './pack-submission-status.js';

interface Props {
  readonly versions: readonly PriorVersionSummary[];
}

/* Confronto com as submissões ANTERIORES do mesmo pack (ADR-0462 §4) — o diff é por
   versão/status/scan (admin-local), não por campos do manifest (deferido). */
export function VersionHistoryCard({ versions }: Props) {
  const copy = usePackSubmissionsContent();
  const v = copy.versionHistory;
  const f = copy.fieldLabels;
  if (versions.length === 0) {
    return (
      <EmptyState
        icon={<GitBranch className="size-6" />}
        title={v.emptyTitle}
        description={v.emptyDescription}
      />
    );
  }
  return (
    <div className="overflow-hidden rounded-md border border-border bg-card">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-border bg-muted/30 text-left text-xs uppercase tracking-wider text-muted-foreground">
            <th className="px-4 py-3 font-medium">{f.version}</th>
            <th className="px-4 py-3 font-medium">{f.status}</th>
            <th className="px-4 py-3 font-medium">{f.scan}</th>
            <th className="px-4 py-3 font-medium">{f.submittedAt}</th>
            <th className="px-4 py-3 font-medium">{f.reviewedAt}</th>
          </tr>
        </thead>
        <tbody>
          {versions.map((item, index) => (
            <tr
              key={`${item.version}-${index}`}
              className="border-b border-border/50 last:border-b-0"
            >
              <td className="px-4 py-3 font-medium text-foreground">v{item.version}</td>
              <td className="px-4 py-3">
                <StatusBadge variant={submissionTone(item.status)} dot>
                  {submissionLabel(item.status, copy.submissionStatusLabels)}
                </StatusBadge>
              </td>
              <td className="px-4 py-3 text-muted-foreground">{item.scanStatus ?? '—'}</td>
              <td className="px-4 py-3 text-muted-foreground">{fmtDate(item.submittedAt)}</td>
              <td className="px-4 py-3 text-muted-foreground">
                {item.reviewedAt !== undefined && item.reviewedAt !== null
                  ? fmtDate(item.reviewedAt)
                  : '—'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
